import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GgMeType } from "@/types/graphql";
import { AuthExtra } from "@/types/AuthExtra.types";

export interface AuthState {
  user: (GgMeType & AuthExtra) | null;
  rolesList: any[];
  tenantsList: any[];
  featuresList: any[];
}

const initialState: AuthState = {
  user: null,
  rolesList: [],
  tenantsList: [],
  featuresList: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    addUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    updateUser: (state, action: PayloadAction<any>) => {
      state.user = { ...state.user, ...action.payload };
    },
    deleteUser: (state) => {
      state.user = null;
      state.rolesList = [];
      state.tenantsList = [];
      state.featuresList = [];
    },
    setRolesList: (state, action: PayloadAction<any[]>) => {
      state.rolesList = action.payload;
    },
    setTenantsList: (state, action: PayloadAction<any[]>) => {
      state.tenantsList = action.payload;
    },
    setFeaturesList: (state, action: PayloadAction<any[]>) => {
      state.featuresList = action.payload;
    },
  },
});

export const {
  addUser,
  updateUser,
  deleteUser,
  setRolesList,
  setTenantsList,
  setFeaturesList,
} = authSlice.actions;

export default authSlice.reducer;
